import React from "react";
import NoteBody from "./NoteBody";
import NoteHeader from "./NoteHeader";
import { getInitialData } from "../utils/index";

class NoteApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notes: getInitialData(),
      arr: [],
    };

    this.onSearchHandler = this.onSearchHandler.bind(this);
    this.onDeleteHandler = this.onDeleteHandler.bind(this);
    this.onArchiveHandler = this.onArchiveHandler.bind(this);
    this.onAddNoteHandler = this.onAddNoteHandler.bind(this);
  }

  async onSearchHandler(search) {
    const searchQuery = search.toLowerCase();
    const searchData = this.state.arr;
    if (searchData.length === 0) {
      await this.setState({ arr: this.state.notes });
    }
    const notes = this.state.arr.filter((note) => {
      const title = note.title.toLowerCase();
      return title.indexOf(searchQuery) !== -1;
    });
    this.setState({ notes });
  }

  onDeleteHandler(id) {
    const notes = this.state.notes.filter((note) => note.id !== id);
    this.setState({ notes, arr: this.state.notes });
  }

  onArchiveHandler(id) {
    const note = this.state.notes.filter((note) => note.id === id)[0];
    const index = this.state.notes.findIndex((x) => x.id === note.id);
    const data = this.state.notes[index];
    if (data.archived === false) {
      data.archived = true;
    } else {
      data.archived = false;
    }
    this.state.arr.push(this.state.notes);
    this.setState((prevState) => {
      return {
        notes: [...prevState.notes],
        arr: this.state.notes,
      };
    });
  }

  onAddNoteHandler({ title, body }) {
    this.state.notes.push({
      id: +new Date(),
      title,
      body,
      archived: false,
      createdAt: new Date().toISOString(),
    });

    this.setState({ notes: this.state.notes, arr: this.state.notes });
  }

  render() {
    return (
      <React.Fragment>
        <NoteHeader searchNote={this.onSearchHandler} />
        <NoteBody
          deleteNote={this.onDeleteHandler}
          archiveNote={this.onArchiveHandler}
          createNote={this.onAddNoteHandler}
          notes={this.state.notes}
        />
      </React.Fragment>
    );
  }
}

export default NoteApp;
